import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  currentLang = new BehaviorSubject<string>('en');
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('en');
  }
  setCurrenttLang(language: string): void {
    if (language != null) {
      if (language == "en" || language == "fr") {
        this.translate.use(language);
        this.currentLang.next(language);
      }
      document.documentElement.setAttribute("lang", language);

    }


  }
  getCurrentLang() {
    if (this.currentLang.value) {
      sessionStorage.setItem("lang_pref", this.currentLang.value)
    }
    return this.currentLang.value;
  }
}
